export default __webpack_public_path__ + "static/media/spencer-davis-0QcSnCM0aMc-unsplash.cbfc3ae2.jpg";